import type { IconName, StackedIcon } from '@/fontawesome';
import type { Ref } from 'vue';
import { ref } from 'vue';

interface ITabDefinitionParams {
    name: string;
    translationKey: string;
    icon?: IconName | StackedIcon;
    badgetext?: Ref<any>;
    alignment?: 'left' | 'right';
    href?: string;
}

export class TabDefinition {
    /**
     * Unique name for the tab.
     *
     * This is used to target the slot for the tab content
     */
    public Name: string;

    /**
     * TranslationKey and default text for this tab
     */
    public TranslationKey: string;

    /**
     * Icon for the tab
     */
    public Icon?: IconName | StackedIcon;

    /**
     * Badge text for the tab
     */
    public Badgetext?: Ref<any>;

    /**
     * Badge color for the tab
     */
    public BadgeColor?: 'danger' | 'warning' | 'success' | 'primary' | 'secondary' | 'info' | 'light' | 'dark' | 'tertiary';

    /**
     * If set, we show a Error icon on the tab
     */
    public HasError?: Ref<any>;

    /**
     * If set, we show a Warning icon on the tab
     */
    public HasWarning?: Ref<any>;

    /**
     * Alignment of the tab
     */
    public Alignment: 'left' | 'right';

    public Href?: string;

    /**
     * Creates a tab
     * @param name The unique name for the tab. Used to target slot for tab content
     * @param translationKey An array with 2 strings containing the translationKey and fallback text for this tab
     * @param icon The icon for the tab
     */
    constructor(
        name: string,
        translationKey: string,
        icon?: IconName | StackedIcon,
        badgetext?: Ref<any>,
        alignment?: 'left' | 'right',
        href?: string,
        hasError?: Ref<boolean>,
        hasWarning?: Ref<boolean>,
    ) {
        this.Name = name;
        this.Icon = icon;
        this.TranslationKey = translationKey;
        this.Badgetext = badgetext;
        this.Alignment = alignment || 'left';
        this.Href = href;
        this.HasError = hasError;
        this.HasWarning = hasWarning;
    }
}
